import { useEffect, useState } from "react";
import BotaoContato from "../../componentes/BotaoContato/BotaoContato.js";
import "../ServicosEngAplicadaProjTec/ServicosEngAplicadaProjTec.css";
import BannerPaginaInterna from "../BannerPaginaInterna/BannerPaginaInterna.js";
import Projetos from "../Projetos/Projetos.js";
import Contato from "../Contato/Contato.js";
import Servicos from "../Servicos/Servicos.js";

function ServicosGestaoEstrategicaESG() {
  const [openItem, setOpenItem] = useState(1);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const elements = document.querySelectorAll(".scroll-reveal-zoom");
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add("visible");
        });
      },
      { threshold: 0.2 },
    );

    elements.forEach((el) => observer.observe(el));
    return () => elements.forEach((el) => observer.unobserve(el));
  }, []);

  return (
    <div>
     <BannerPaginaInterna
  tag="Gestão Estratégica em ESG "
  titulo="Gestão Estratégica em ESG "
  descricao="Nossos serviços são voltados para organizações que buscam melhorar seu desempenho ambiental, fortalecer sua governança e atender às exigências de mercado, investidores e órgãos reguladores, com abordagem técnica e orientada a resultados."
  textoBotao="Solicitar Orçamento"
  rotaBotao="https://wa.me/5532984053160?text=Olá, quero um orçamento para Gestão Estratégica em ESG "
  mostrarBotaoOutline={true}
  textoBotaoOutline="Fale com Especialista"
  rotaBotaoOutline="https://wa.me/5532984053160?text=Olá, quero falar com um especialista em Gestão Estratégica em ESG "
/>

      <main className="servicos-page py-5">
        {/* HEADER */}

        {/* LISTA COM DETAILS */}
        <section className="s scroll-reveal-zoom">
          <div className="titulo-bloco">
            <h2>Nossos Serviços Especializados</h2>
            <p>
              Clique nos itens abaixo para conhecer detalhes de nossa atuação
              técnica.
            </p>
          </div>

          <p>
  A Âmbar Soluções em Engenharia e Meio Ambiente atua com <strong>gestão estratégica em ESG (Environmental, Social and Governance)</strong>, apoiando empresas na implementação de práticas sustentáveis, melhoria de desempenho e atendimento às <strong>exigências de mercado, investidores e órgãos reguladores</strong>. Nossos serviços são voltados para organizações que buscam <strong>fortalecer sua governança, reduzir riscos e gerar valor sustentável</strong>.
</p>

<p>
  Desenvolvemos <strong>diagnóstico ESG completo</strong>, avaliando o nível de maturidade da empresa nas dimensões <strong>ambiental, social e de governança</strong>, além da <strong>estruturação e implementação de programas ESG</strong> com definição de metas, indicadores e planos de ação personalizados. Atuamos alinhados às <strong>boas práticas, normas e diretrizes internacionais</strong>, garantindo consistência e credibilidade na estratégia adotada.
</p>

<p className="mb-4">
  Também realizamos a <strong>gestão contínua das práticas ESG</strong>, com acompanhamento de indicadores e melhoria contínua, além da elaboração de <strong>relatórios de sustentabilidade (ESG Report)</strong> para comunicação com stakeholders, investidores e órgãos reguladores. Com <strong>alto rigor técnico, visão estratégica e abordagem orientada a resultados</strong>, ajudamos empresas a se posicionarem de forma competitiva e sustentável no mercado.
</p>


          <div className="accordion">
            <div className="accordion">
{/* ITEM 13 */}
<details className="item" open={openItem === 13} onClick={(e) => { e.preventDefault(); setOpenItem(openItem === 13 ? null : 13); }}>
  <summary className="item-summary">
    <div className="item-header">
      <p className="item-titulo">Diagnóstico ESG Estratégico (ESG Start)</p>
    </div>
    <span className="icone"><i className="fa-solid fa-chevron-down"></i></span>
  </summary>

  <div className="item-conteudo">
    <div className="bloco-descricao-servico">
      <p>
        O <strong>ESG Start</strong> consiste na realização de um <strong>diagnóstico ESG completo</strong>,
        com avaliação do <strong>nível de maturidade</strong> da empresa em relação às práticas
        <strong> ambientais, sociais e de governança</strong>.
        <br />
        O serviço inclui <strong>análise de processos internos</strong>,
        <strong> identificação de riscos e oportunidades</strong>, além do
        <strong> mapeamento de requisitos legais e de mercado</strong>,
        estabelecendo uma base técnica para a evolução da <strong>estratégia ESG</strong>.
      </p>

      <BotaoContato
        texto="Entre em Contato"
        rota="https://wa.me/5532984053160?text=Olá, gostaria de mais informações sobre: Diagnóstico ESG (ESG Start)"
      />
    </div>
  </div>
</details>

{/* ITEM 14 */}
<details className="item" open={openItem === 14} onClick={(e) => { e.preventDefault(); setOpenItem(openItem === 14 ? null : 14); }}>
  <summary className="item-summary">
    <div className="item-header">
      <p className="item-titulo">Programa de Implementação ESG (ESG Struct)</p>
    </div>
    <span className="icone"><i className="fa-solid fa-chevron-down"></i></span>
  </summary>

  <div className="item-conteudo">
    <div className="bloco-descricao-servico">
      <p>
        O <strong>ESG Struct</strong> é voltado para a <strong>estruturação e implementação de práticas ESG</strong>,
        com definição de <strong>diretrizes</strong>, <strong>metas</strong> e
        <strong> indicadores alinhados</strong> ao perfil da empresa.
        <br />
        Desenvolvemos <strong>planos de ação personalizados</strong>, integrando aspectos
        <strong> ambientais, sociais e de governança</strong> à operação, garantindo aderência a
        <strong> boas práticas</strong>, <strong>normas</strong> e <strong>exigências do mercado</strong>.
      </p>

      <BotaoContato
        texto="Entre em Contato"
        rota="https://wa.me/5532984053160?text=Olá, gostaria de mais informações sobre: Implementação ESG (ESG Struct)"
      />
    </div>
  </div>
</details>

{/* ITEM 15 */}
<details className="item" open={openItem === 15} onClick={(e) => { e.preventDefault(); setOpenItem(openItem === 15 ? null : 15); }}>
  <summary className="item-summary">
    <div className="item-header">
      <p className="item-titulo">Gestão Contínua ESG (ESG Management)</p>
    </div>
    <span className="icone"><i className="fa-solid fa-chevron-down"></i></span>
  </summary>

  <div className="item-conteudo">
    <div className="bloco-descricao-servico">
      <p>
        O <strong>ESG Management</strong> contempla a <strong>gestão contínua das práticas ESG</strong>,
        com <strong>acompanhamento de indicadores</strong>, <strong>revisão de estratégias</strong> e
        <strong> suporte técnico permanente</strong>.
        <br />
        Esse serviço permite a <strong>consolidação da cultura ESG</strong> na empresa, promovendo
        <strong> melhoria contínua</strong>, <strong>controle de desempenho</strong> e
        <strong> transparência nas ações desenvolvidas</strong>.
      </p>

      <BotaoContato
        texto="Entre em Contato"
        rota="https://wa.me/5532984053160?text=Olá, gostaria de mais informações sobre: Gestão ESG (ESG Management)"
      />
    </div>
  </div>
</details>

{/* ITEM 16 */}
<details className="item" open={openItem === 16} onClick={(e) => { e.preventDefault(); setOpenItem(openItem === 16 ? null : 16); }}>
  <summary className="item-summary">
    <div className="item-header">
      <p className="item-titulo">Relatório de Sustentabilidade (ESG Report)</p>
    </div>
    <span className="icone"><i className="fa-solid fa-chevron-down"></i></span>
  </summary>

  <div className="item-conteudo">
    <div className="bloco-descricao-servico">
      <p>
        Elaboramos <strong>Relatórios de Sustentabilidade (ESG Report)</strong> com base em
        <strong> diretrizes reconhecidas</strong>, consolidando informações sobre o desempenho
        <strong> ambiental, social e de governança</strong> da empresa.
        <br />
        Os relatórios são estruturados para atender demandas de
        <strong> stakeholders</strong>, <strong>investidores</strong> e
        <strong> órgãos reguladores</strong>, contribuindo para a
        <strong> transparência</strong> e <strong>posicionamento estratégico</strong>.
      </p>

      <BotaoContato
        texto="Entre em Contato"
        rota="https://wa.me/5532984053160?text=Olá, gostaria de mais informações sobre: Relatório ESG (ESG Report)"
      />
    </div>
  </div>
</details>
              </div>  
          </div>
        </section>
      </main>
      <Projetos />
      <Servicos />
      <Contato />
    </div>
  );
}

export default ServicosGestaoEstrategicaESG;
